import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

// Component
import MainHeader from '../components/MainHeader'
import GmCard from '../components/playerInterface/FreeAgentGmCard'
import PlayerStats from '../components/playerInterface/PlayerStats'
import ContractInfo from '../components/playerInterface/ContractInfo'
import Loader from '../components/Loader'
import PlayerInfoBottom from '../components/PlayerInfoBottom'
import { getFreeAgentRosterPlayer } from '../redux/actions/rosterAction'

const AgentPlayerInterface = () => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const [player, setPlayer] = useState({})
  const [news, setNews] = useState(null)
  const [loading, setLoading] = useState(true)

  const { id } = useParams()

  useEffect(() => {
    getData()
  }, [id])

  const getData = async () => {
    setLoading(true)
    const res = await getFreeAgentRosterPlayer({ id: Number(id), date: SETTING?.date })
    if (res) {
      setPlayer(res?.player)
      setNews(res?.news)
    }
    setLoading(false)
  }

  return (
    <div className='player_interface_container'>
      <MainHeader />

      <hr className='divider' />

      {loading ? (
        <Loader />
      ) : (
        <>
          <GmCard playerData={player} news={news} />

          <PlayerInfoBottom player={player} />

          <section className='player_info_container'>
            <PlayerStats />
            <ContractInfo data={player?.contractInfo} />
          </section>
        </>
      )}
    </div>
  )
}

export default AgentPlayerInterface
